import styled from 'styled-components';

import Icon from '../../../components/Icon';
import ListItem from '../../../components/ListItem';
import formatDateTime from '../../../utils/formatDateTime';

type PaymentStatusItemProps = {
  label: string;
  at: string;
  by?: string | null;
  rejectionCode?: string | null;
  rejectionReason?: string | null;
  status: 'completed' | 'rejected';
};

const PaymentStatusHistoryItem = ({
  label,
  status,
  at,
  by = null,
  rejectionCode = null,
  rejectionReason = null,
}: PaymentStatusItemProps) => {
  return (
    <ListItem theme={status === 'completed' ? 'green' : 'red'}>
      <HistoryItemContentWrapper>
        <StatusWrapper status={status}>
          <Icon
            iconName={
              status === 'completed' ? 'faCheckCircle' : 'faTimesCircle'
            }
          />
        </StatusWrapper>
        <ContentWrapper>
          <h4>{label}</h4>
          {formatDateTime(at)} {by && `by ${by}`}
          {rejectionCode && (
            <>
              <br />
              {rejectionCode}: {rejectionReason}
            </>
          )}
        </ContentWrapper>
      </HistoryItemContentWrapper>
    </ListItem>
  );
};

export default PaymentStatusHistoryItem;

const HistoryItemContentWrapper = styled.div`
  display: flex;
`;

const StatusWrapper = styled.div<{
  status: 'completed' | 'rejected';
}>`
  display: flex;
  align-items: flex-start;
  background-color: ${({ status }) =>
    status === 'completed' ? '#3c763d' : '#721c24'};
  font-size: 1.125rem;
  color: ${({ status }) => (status === 'completed' ? '#dff0d8' : '#f8d7da')};
  margin-left: -0.5rem;
  margin-top: -0.5rem;
  margin-bottom: -0.5625rem;
  border-bottom-left-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  padding: 0.5rem 0.25rem;
  margin-right: 0.25rem;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
